if (!customElements.get('logo-list')) {
  class LogoList extends HTMLElement {
    constructor() {
      super();
      this.inners = this.querySelectorAll('.logo-list__inner.swipe-on-mobile');
      if (this.inners.length > 0) {
        this.adjustElements();
        window.addEventListener('resize', this.adjustElements.bind(this))
      }

    }
    adjustElements() {
      if (window.innerWidth <= 749) {
        this.inners.forEach(e => {
          let innerWidth = 0;
          const innerElements = e.querySelectorAll('.logo-list__logo');
          innerElements.forEach(ie => {
            innerWidth += ie.clientWidth + +this.dataset.gap
          })
          innerWidth -= +this.dataset.gap

          if (innerWidth > e.clientWidth - 30) {
            e.style.justifyContent = 'start';
          } else {
            e.style.justifyContent = this.dataset.alignment
          }
        })
      } else {
        this.inners.forEach(e => {
          e.style.justifyContent = this.dataset.alignment
        })
      }
    }
  }

  customElements.define('logo-list', LogoList)
}